export default __webpack_public_path__ + "static/media/trr-drink-specialty-saltedcream.c87228f5.png";